export const SCREEN_CONNECT_HEADER = ['LOGGED IN USER', 'OPERATING SYSTEM', 'ORGANIZATION', 'actions']

export const ACTION_ICON = {
  Download_Installer: 'Download_Installer',
  Download_app: 'Download_app',
  Launch_app : 'Launch_app',
}
